export default defineNuxtPlugin(() => {
  const router = useRouter();
  let controller = new AbortController();

  router.beforeEach((to, from) => {
    if (to.fullPath === from.fullPath) return;

    const previousController = controller;
    controller = new AbortController();
    previousController.abort(
      new DOMException("cancel by user router", "AbortError"),
    );
  });

  return {
    provide: {
      apiRequestSignal: () => controller.signal,
    },
  };
});
